export default __webpack_public_path__ + "static/media/frontdesk-banner.f49b6d77.webp";